export const ipsPoints = [
  { value: 0, label: 0 },
  { value: 5, label: 5 },
  { value: 15, label: 15 },
  { value: 25, label: 25 },
  { value: 50, label: 50 },
  { value: 100, label: 100 },
  { value: 150, label: 150 },
  { value: 200, label: 200 }
];
